<h2>{{ 'COMMON.titles.viewLastFiveTransactions' + labelPrefix | translate }}</h2>
<div class="table-area">
  <app-table-view
    [config]="topTransactionsTableConfig"
    [data]="topTransactions">
  </app-table-view>
</div>
